module.exports = __webpack_public_path__ + "img/retkipaikka-artikkelit.68daf94f.jpg";